import styled from "styled-components";
import theme from "../../../theme";

export const CareseBookContainer = styled.div`
  margin-bottom: 96px;
  @media (max-width: 991px) {
    margin-bottom: 96px;
  }
  @media (max-width: 480px) {
    margin-bottom: 72px;
  }
`;

export const SingleEbook = styled.div`
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: center;
margin-top: 72px;
  a {
    color: ${theme.black};
  }
  h4 {
      font-size: 23px;
      line-height: 30px;
      color: ${theme.black};
      margin-top: 15px;
      margin-bottom: 0;
  }

  @media (max-width: 768px){
    margin-top: 40px;
  }
`;
